import { pletApiRequest } from './client';

export const SearchAPI = {
  search: async ({ query, scope = 'all', campaignId = null, limit = 50 }) => {
    const result = await pletApiRequest('/search', {
      method: 'POST',
      body: JSON.stringify({ query, scope, campaignId, limit }),
    });
    return result;
  },

  docLinks: async (docId) => {
    const result = await pletApiRequest('/search', {
      method: 'POST',
      body: JSON.stringify({ docId }),
    });
    return result;
  },
};
